// Product photos are stored at up to 1600px for the product page, which is far more than a card,
// cart line or list needs. The server keeps a 600px copy of each (made on first request):
//   /api/shopImages/image_123.webp  ->  /api/shopImages/thumbs/image_123.webp
// Anything that isn't an uploaded shop photo is returned unchanged.
const SHOP_IMAGE_PATTERN = /^\/api\/shopImages\/([\w-]+)\.(webp|jpe?g|png)$/i;

export const cardImage = (imagePath) => {
  const match = SHOP_IMAGE_PATTERN.exec(imagePath ?? "");
  return match ? `/api/shopImages/thumbs/${match[1]}.webp` : imagePath;
};
